import { Injectable } from '@angular/core';
import {Subject} from "rxjs";

declare var YT;

@Injectable({
  providedIn: 'root'
})
export class YoutubeService {

  public player;
  public modal;
  private isLoaded = false;
  private _playerLoaded = new Subject<any>();
  get playerLoaded$(){
    return this._playerLoaded.asObservable()
  }

  constructor() {

    if (!this.isLoaded){

      // 2. This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');

      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // 3. This function creates an <iframe> (and YouTube player)
      //    after the API code downloads.
      window['onYouTubeIframeAPIReady'] = this.onYouTubeIframeAPIReady.bind(this);
      this.isLoaded = true;
    }
  }

  onYouTubeIframeAPIReady() {
    this.player = new YT.Player('videoModalPlayer', {
      height: '390',
      width: '640',
      videoId: 'HPh_t4zU_go',
      playerVars: {
        'playsinline': 1
      }
    });
    this.modal = jQuery(document.querySelector('#es-video-modal'));
    this._playerLoaded.next(this.player);
  }

  openModal(val) {
    if (this.modal && this.player) {
      this.modal.modal({backdrop: true, keyboard: false, show: true});
      this.modal.data('bs.modal')._config.backdrop = true;
      this.modal.data('bs.modal')._config.keyboard = false;
      let self = this;
      this.modal.on('shown.bs.modal', function() {
        // self.modal.find('.modal-body').height(self.modal.find('.modal-content').height() - 90);
        self.player.setSize(
          self.modal.find('.modal-body').width(),
          self.modal.find('.modal-body').height(),
        );

        var m = val.match(/\/((youtu\.be\/([^\/\?]+)\?|([^\/\?]+)[^\/\?\&]*(?!\?v=)|([^\/\&\?]*\?\bv=([^\/\&\?]+))))[^\/\?]*$/);
        var code = '';
        for (var i = m.length - 1; i >= 0; i--) {
          if (m[i] !== undefined) {
            code = m[i];
            break;
          }
        }
        m = val.match(/\bt=(\d+)/);

        self.player.loadVideoById(code, m ? m[1] : 0);
        self.modal.off('shown.bs.modal');
      });

      this.modal.on('hide.bs.modal', function() {
        self.player.stopVideo();
        self.modal.off('hide.bs.modal');
      });
    }
  }
}
